import { createSlice } from '@reduxjs/toolkit';

interface IPlayground {
    filterLabel: string;
    searchName: string;
    hoveredId: null;
    showSetTimer: boolean;
    showEndTime: boolean;
    showCustomTime: boolean;
    showStopWatch: boolean;
    timerDuration: number;
    timerSeconds: number;
    stopwatchSeconds: number;
    timerIsActive: boolean;
    stopWatchHours: number;
    stopWatchMinutes: number;
    stopWatchSeconds: number;
    stopWatchIsActive: boolean;
    endsInHour: number;
    endsInMinutes: number;
}

const initialState: IPlayground = {
    filterLabel: "",
    searchName: "",
    hoveredId: null,
    showSetTimer: true,
    showEndTime: false,
    showCustomTime: false,
    showStopWatch: false,
    timerDuration: 0,
    timerSeconds: 0,
    stopwatchSeconds: 0,
    timerIsActive: false,
    stopWatchHours: 0,
    stopWatchMinutes: 0,
    stopWatchSeconds: 0,
    stopWatchIsActive: false,
    endsInHour: 0,
    endsInMinutes: 45,
};

const slice = createSlice({
    name: 'playground',
    initialState,
    reducers: {
        setFilterLabel(state, action) {
            state.filterLabel = action.payload;
        },
        setSearchName(state, action) {
            state.searchName = action.payload;
        },
        setHoveredId(state, action) {
            state.hoveredId = action.payload;
        },
        setShowSetTimer(state, action) {
            state.showSetTimer = action.payload;
        },
        setShowEndTime(state, action) {
            state.showEndTime = action.payload;
        },
        setShowCustomTime(state, action) {
            state.showCustomTime = action.payload;
        },
        setShowStopWatch(state, action) {
            state.showStopWatch = action.payload;
        },
        setTimerSeconds(state, action) {
            state.timerSeconds = action.payload;
        },
        setStopWatchTimerSeconds(state, action) {
            state.stopwatchSeconds = action.payload;
        },
        setTimerDuration(state, action) {
            state.timerDuration = action.payload;
        },
        setTimerIsActive(state, action) {
            state.timerIsActive = action.payload;
        },
        setStopWatchHours(state, action) {
            state.stopWatchHours = action.payload;
        },
        setStopWatchMinutes(state, action) {
            state.stopWatchMinutes = action.payload;
        },
        setStopWatchSeconds(state, action) {
            state.stopWatchSeconds = action.payload;
        },
        setStopWatchIsActive(state, action) {
            state.stopWatchIsActive = action.payload;
        },
        setEndsInHour(state, action) {
            state.endsInHour = action.payload;
        },
        setEndsInMinutes(state, action) {
            state.endsInMinutes = action.payload;
        },
    },
});


export const PlaygroundAction = slice.actions;

export const setFilterLabel = (data) => async (dispatch) => {
    dispatch(slice.actions.setFilterLabel(data));
};

export const setHoveredId = (data) => async (dispatch) => {
    dispatch(slice.actions.setHoveredId(data));
};

export const setSearchName = (data) => async (dispatch) => {
    dispatch(slice.actions.setSearchName(data));
};

export const setShowSetTimer = (data) => async (dispatch) => {
    dispatch(slice.actions.setShowSetTimer(data));
};

export const setShowEndTime = (data) => async (dispatch) => {
    dispatch(slice.actions.setShowEndTime(data));
};

export const setShowCustomTime = (data) => async (dispatch) => {
    dispatch(slice.actions.setShowCustomTime(data));
};

export const setShowStopWatch = (data) => async (dispatch) => {
    dispatch(slice.actions.setShowStopWatch(data));
};

export const setTimerSeconds = (data) => async (dispatch) => {
    dispatch(slice.actions.setTimerSeconds(data));
};

export const setStopWatchTimerSeconds = (data) => async (dispatch) => {
    dispatch(slice.actions.setStopWatchTimerSeconds(data));
};

export const setTimerDuration = (data) => async (dispatch) => {
    dispatch(slice.actions.setTimerDuration(data));
};

export const setTimerIsActive = (data) => async (dispatch) => {
    dispatch(slice.actions.setTimerIsActive(data));
};

export const setStopWatchHours = (data) => async (dispatch) => {
    dispatch(slice.actions.setStopWatchHours(data));
};

export const setStopWatchMinutes = (data) => async (dispatch) => {
    dispatch(slice.actions.setStopWatchMinutes(data));
};

export const setStopWatchSeconds = (data) => async (dispatch) => {
    dispatch(slice.actions.setStopWatchSeconds(data));
};

export const setStopWatchIsActive = (data) => async (dispatch) => {
    dispatch(slice.actions.setStopWatchIsActive(data));
};

export const setEndsInHour = (data) => async (dispatch) => {
    dispatch(slice.actions.setEndsInHour(data));
};

export const setEndsInMinutes = (data) => async (dispatch) => {
    dispatch(slice.actions.setEndsInMinutes(data));
};

export const reducer = slice.reducer;

export default slice;
